import React from 'react';
import './styles/testdrivePromo.scss';
import {linkWithUtm} from "../../helpers/linkWithUtm";

const TestdrivePromo = (props) => {
    return (
      <section className="testdrivePromo" id="testdrivePromo">
        <div className="testdrivePromo__container container">
          <div className="testdrivePromo__head">
            <h2 className="section-title">Безлимит на 1 день</h2>
          </div>
          <div className="testdrivePromo__content">
            <div className="testdrivePromo__content_text-block">
              <div className="testdrivePromo__content-title"><h3 className="limegreen">Тест-драйв</h3></div>
              <p className="testdrivePromo__content-text">
                Получи безлимитный доступ в клуб на&nbsp;1&nbsp;день. Скидка при покупке длительной карты в течение 3-х дней после тест-драйва.
              </p>
              <div className="testdrivePromo__content-features">
                <div className="testdrivePromo__content-features-item">
                  <img loading="lazy" src={require("../../static/images/icons/bike.svg").default} width="24px" alt=""/>
                  <p>Тренажерный зал</p>
                </div>
                <div className="testdrivePromo__content-features-item">
                  <img loading="lazy" src={require("../../static/images/icons/pool.svg").default} width="24px" alt=""/>
                  <p>Спортивный бассейн</p>
                </div>
                <div className="testdrivePromo__content-features-item">
                  <img loading="lazy" src={require("../../static/images/icons/yoga.svg").default} width="24px" alt=""/>
                  <p>Групповые программы</p>
                </div>
                <div className="testdrivePromo__content-features-item">
                  <img loading="lazy" src={require("../../static/images/icons/spa.svg").default} width="24px" alt=""/>
                  <p>SPA-зона с хаммамом и сауной</p>
                </div>
              </div>
              <a href={linkWithUtm('/processing/testdrive')} className="btn-blue btn-blue--primary">Хочу попробовать</a>
            </div>
            <div className="testdrivePromo__content_image-block">
              <img loading="lazy" src={require('../../static/images/common/testdrive.png')} alt="Занятие на беговой дорожке" />
            </div>
          </div>
        </div>
      </section>
    );
}

export default TestdrivePromo;
